'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sprite = undefined;

var _emojioneSpritePositions = require('./emojione-sprite-positions');

var _emojioneSpritePositions2 = _interopRequireDefault(_emojioneSpritePositions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = function defaults(codepoint) {
    return {
        textIndent: '-9999em',
        imageRendering: 'optimizeQuality',
        fontSize: 'inherit',
        height: '1.5em',
        width: '1.5em',
        top: '-3px',
        position: 'relative',
        display: 'inline-block',
        margin: '0 .15em',
        lineHeight: 'normal',
        verticalAlign: 'middle',
        backgroundImage: 'url("assets/emojione.sprites.png")',
        backgroundSize: '3600%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: _emojioneSpritePositions2.default[codepoint]
    };
};

var sprite = exports.sprite = function sprite(codepoint) {
    var style = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    return Object.assign({}, defaults(codepoint), style);
};

exports.default = {
    sprite: sprite
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-emojione/lib/styles/emojione-sprite.js
 ** module id = 575
 ** module chunks = 0
 **/